import { InputNumber, Space } from 'antd';
import { TextService } from '../../Services/TextService';

/**
 * How many days before the deadline (or the first time) the automatic reminder is sent.
 */
export const ReminderDaysInput = (props: { days: number, onChange: (days: number) => void }) => {
    const GetText = TextService.GetText;

    return <Space size={6} wrap style={{ marginTop: 6, textAlign: "left" }}>
        <span>{GetText("Create_AutomaticReminder_DaysBefore_Prefix")}</span>
        <InputNumber
            data-testid="reminder-days"
            min={0}
            max={60}
            precision={0}
            size="small"
            style={{ width: 64 }}
            value={props.days}
            onChange={(value) => props.onChange(value ?? 2)}
        />
        <span>{GetText("Create_AutomaticReminder_DaysBefore_Suffix")}</span>
    </Space>;
};
